import React, { Component } from "react";
import { connect } from "react-redux";
import { pathToJS, firebaseConnect } from "react-redux-firebase";
import { Redirect } from "react-router-dom";
import LoginForm from "./loginForm";

import "./style.scss";

export class Login extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {};
  }

  componentWillMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <div className="LoginPage">
        {this.props.auth &&
          <Redirect
            to={{
              pathname: "/group/-KiqhK57QJfMXKizt8nc"
            }}
          />}
        <h1>Welcome to SIMI</h1>
        <h2>Please Login</h2>
        <div className="content">
          <LoginForm />
        </div>
        {this.props.authError &&
          <div className="card">{this.props.authError.message}</div>}
      </div>
    );
  }
}

export default connect(
  // Map state to props
  ({ firebase }) => ({
    authError: pathToJS(firebase, "authError"),
    auth: pathToJS(firebase, "auth")
  })
)(firebaseConnect()(Login));



// WEBPACK FOOTER //
// ./src/routes/login/index.js